import React, { createContext, useEffect, useState } from 'react';

//create context
export const CartContext = createContext();

const CartProvider = ({ children }) => {
  // cart state
  const [cart, setCart] = useState([]);
  //item amount state
  const [itemAmount, setItemAmount] = useState(0);

  //total price state
  const [total, setTotal] = useState(0)

  useEffect(() => {
    const total = cart.reduce((accumulator, currentItem) => {
      return accumulator + currentItem.price * currentItem.amount
    }, 0);
    setTotal(total)
  })

  
  //update item amount
  useEffect(() => {
    if (cart) {
      const amount = cart.reduce((accumulator, currentItem) => {
        return accumulator + currentItem.amount;
      }, 0);
      setItemAmount(amount)
    }
  },[cart])

  //add to cart
  const addToCart = (product, id) => {
    const newItem = { ...product, amount: 1 };
    //check if item already exist in the cart
    const cartItem = cart.find(item => {
      return (
        item.id === id
      )
    })
    //id item in the cart already
    if (cartItem) {
      const newCart = [...cart].map(item => {
        if (item.id === id) {
          return { ...item, amount: cartItem.amount + 1 };
        }
        else {
          return item;
        }
      })
      setCart(newCart)
    } else {
      setCart([...cart, newItem])
    }
  };

  // remover from cart
  const removeFromCart = (id) => {
    const newCartfresh = cart.filter(item =>  item.id !== id)
    setCart(newCartfresh)
  }
  //clear cart
  const clearCart = () => {
    setCart([]);
  };

  //increase amount
  const increaseAmount = (id) => {
    const cartItem = cart.find(item => item.id === id);
    addToCart(cartItem, id);
}
  // decrease amount
  const decreaseAmount = (id) => {
    // find the cart item properly
    const cartItem = cart.find(item => item.id === id);
    if (!cartItem) return; // nothing to do

    if (cartItem.amount > 1) {
      // decrease amount by 1
      const newCart = cart.map(item => {
        if (item.id === id) {
          return { ...item, amount: item.amount - 1 };
        }
        return item;
      });
      setCart(newCart);
    } else {
      // if amount is 1, remove the item
      removeFromCart(id);
    }
  };

  return (
    <CartContext.Provider value={{ cart, addToCart, removeFromCart, clearCart, increaseAmount, decreaseAmount, itemAmount, total }}>
      {children}
    </CartContext.Provider>
  );
};

export default CartProvider;
